import { Injectable } from '@angular/core';

@Injectable()
export class ShareModel {

    constructor(){
        console.log('ShareModel call');
        if(this.searchModel=null) 
            this.searchModel=new SearchModel();
    }

    public searchModel:SearchModel;
} 


@Injectable()
export class SearchModel {

    public minDate:string;
    public maxDate:string;

    public cityId:string;

    public startStation:string;

    public stopName:string;

    public stopId:string;


    public drvDate:string;

    public key:string;
}

@Injectable()
export class PassengerContainer {


    public num:number;

    public passengers:Passenger[];

    public defaultBaoXian:BaoXian;
}

@Injectable()
export class Passenger{



    // constructor(id:number){
    //     this.id=id;
    // }

    public id:number;

    public name:string;

    public phone:string;

    public idCard:string;

    public sort:number;

    public selected:boolean;

    public catalog:number;
}

@Injectable()
export class BaoXian{

    public id:number;

    public faceValue:number;

    public compensation:number;

    public insuranceProductName:string;
}


// WEBPACK FOOTER //
// ./src/models/SearchModel.ts